import { render, staticRenderFns } from "./FightResult.vue?vue&type=template&id=af2bc64c&"
import script from "./FightResult.vue?vue&type=script&lang=js&"
export * from "./FightResult.vue?vue&type=script&lang=js&"
import style0 from "./FightResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports